import { api } from "./client";
import { unwrap } from "./errors";

/**
 * Transcribe a recorded audio blob to text via `POST /v1/audio/transcriptions`
 * (Groq Whisper on the backend). The blob is sent as multipart/form-data — the
 * `bodySerializer` returns a `FormData` so the browser sets the multipart
 * boundary itself (openapi-fetch would otherwise JSON-encode the body). The auth
 * header is still injected by the shared client middleware.
 */
export async function transcribeAudio(blob: Blob, fileName = "recording.webm"): Promise<string> {
  const result = unwrap(
    await api.POST("/v1/audio/transcriptions", {
      body: { file: blob as unknown as string },
      bodySerializer(body) {
        const form = new FormData();
        form.append("file", body.file as unknown as Blob, fileName);
        return form;
      },
    }),
  );
  return result.text;
}
